import React, { FC } from 'react';

import { DataAccessSummary } from '@ariksa/inventory-core';
import { Box } from '@chakra-ui/react';

import { ButtonGroup } from 'components/DataEntry';

import {
  DataAccessFilters,
  FILTER_PRESETS,
  FilterPreset,
  getFilterPreset,
  getFilterPresetItems,
} from './utils';

interface DataFilterButtonsProps {
  summary?: DataAccessSummary;
  filters: DataAccessFilters;

  onChange(filters: DataAccessFilters): void;
}

/**
 * All, High privileges, Sensitive, and High & Sensitive, each with its
 * database count, in the section header like the Principals tab's account
 * buttons. A click sets both filters.
 */
export const DataFilterButtons: FC<DataFilterButtonsProps> = props => {
  const { summary, filters, onChange } = props;
  const items = getFilterPresetItems(summary);
  const selected = getFilterPreset(filters);
  return (
    // The header toggles the section; a click on a button must not.
    <Box onClick={e => e.stopPropagation()}>
      <ButtonGroup
        items={items}
        value={items.find(item => item.value === selected)}
        onClick={item => onChange(FILTER_PRESETS[item.value as FilterPreset])}
      />
    </Box>
  );
};
